import get_rest_instance from "../../shared/services/common.service";

class ReportService {
  getReportByDateService(fleet_id, from, to) {
    return get_rest_instance("server").get("/report_by_date", {
      params: { fleet_id: fleet_id, from: from, to: to },
    });
  }
}

export default new ReportService();
